import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const eventInfoStyles = makeStyles((theme: Theme) =>
    createStyles({
        subTitle: {
            color: "#525252",
        },
        subTitleSecondVar: {
            color: "rgba(24, 24, 24, 1)",
            fontWeight: 500,
        },
        textUpperCase: {
            textTransform: "uppercase",
        },
        alignMargin: {
            marginTop: "5px",
        },
        eventId: {
            color: "#181818",
            fontWeight: 500,
            fontSize: "40px",
            marginBottom: "12px",
        },
        complete: {
            color: "rgba(0, 175, 65, 1)",
            fontWeight: 500,
        },
        review: {
            color: "rgba(153, 110, 0, 1)",
            fontWeight: 500,
        },
        new: {
            color: "rgba(179, 0, 33, 1)",
            fontWeight: 500,
        },
        iconSpacing: {
            marginRight: "6px",
            marginTop: "2px",
        },
        iconContainer: {
            display: "flex",
        },

        radio: {
            "& .MuiRadio-colorSecondary.Mui-checked": {
                color: "#270ADC !important",
                backgroundColor: "white !important",
            },
            "& .MuiRadio-colorSecondary": {
                padding: "0px 0px 0px 0px",
                margin: "5px 7px 5px 5px",
                "&:hover": {
                    backgroundColor: "transparent",
                },
            },
        },
        radioButtonContainer: {
            position: "absolute",
            padding: "10px 20px",
            display: "flex",
            maxWidth: "150px",
            borderRadius: "0px",
            zIndex: 1,
        },
        smallIndicator: {
            height: "4vh",
            width: "10vh",
            display: "flex",
            alignItems: "center",
        },

        assignButton: {
            float: "right",
            margin: "0px 50px 0px 0px",
            border: "1px solid #270ADC",
            borderRadius: "4px",
            padding: "5px 35px 5px 35px",
            color: "#270ADC",
            "&:hover": {
                color: "white",
                backgroundColor: "#270ADC",
            },
        },
        reopenButton: {
            float: "right",
            margin: "10px 50px 0px 0px",
            border: "1px solid #270ADC",
            borderRadius: "4px",
            padding: "5px 35px 5px 35px",
            color: "#270ADC",
            "&:hover": {
                color: "white",
                backgroundColor: "#270ADC",
            },
        },
        fileIconSpace: {
            display: "flex",
            color: "#270ADC",
            cursor: "pointer",
            marginTop: "7px",
        },
        fileIcon: {
            margin: "-2px 3px 0px 0px",
        },
        disabledField: {
            display: "flex",
            marginTop: "7px",
            color: "rgba(153, 153, 153, 1)",
            cursor: "auto",
        },
        picker: {
            "&:focus-visible": {
                outline: "none",
            },
            "&:focus": {
                border: "1px solid rgba(39, 10, 220, 1)",
            },
            fontSize: "14px",
            fontWeight: 500,
            paddingLeft: "10px",
            height: "33px",
            width: "200px",
            border: "1px solid rgba(0, 0, 0, 0.23)",
            borderRadius: "4px",
            backgroundColor: "transparent",
        },
    })
);
